 import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

function Activity() {
    return (
        <>
<FontAwesomeIcon icon="fa-solid fa-folder" style={{ color: '#bebe05', fontSize: '16px', padding:'4px'}} />

  
      
      </>
    )
  }
  
  export default Activity
  